document.querySelectorAll('.partner-carousel__container').forEach((container) => {
    const track = container.querySelector('.partner-carousel__track');
    const viewport = container.querySelector('.partner-carousel__viewport');
    const prevBtn = container.querySelector('.partner-carousel__nav--prev');
    const nextBtn = container.querySelector('.partner-carousel__nav--next');

    let isAnimating = false;

    function getVisibleCount() {
        const vw = viewport.offsetWidth;
        const count = Math.floor(vw / 125);
        return Math.max(2, Math.min(count, 3));
    }

    function layoutItems() {
        const count = getVisibleCount();
        const itemWidth = viewport.offsetWidth / count;
        Array.from(track.children).forEach((item) => {
            item.style.width = itemWidth + 'px';
            item.style.minWidth = itemWidth + 'px';
        });
    }

    function goNext() {
        if (isAnimating) return;
        isAnimating = true;

        const count = getVisibleCount();
        const itemWidth = viewport.offsetWidth / count;

        track.style.transition = 'transform 0.3s ease';
        track.style.transform = `translateX(-${itemWidth}px)`;

        track.addEventListener('transitionend', function handler() {
            track.removeEventListener('transitionend', handler);
            track.style.transition = 'none';
            track.appendChild(track.firstElementChild);
            track.style.transform = 'translateX(0)';
            isAnimating = false;
        }, { once: true });
    }

    function goPrev() {
        if (isAnimating) return;
        isAnimating = true;

        const count = getVisibleCount();
        const itemWidth = viewport.offsetWidth / count;

        track.style.transition = 'none';
        track.insertBefore(track.lastElementChild, track.firstElementChild);
        track.style.transform = `translateX(-${itemWidth}px)`;

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                track.style.transition = 'transform 0.3s ease';
                track.style.transform = 'translateX(0)';

                track.addEventListener('transitionend', function handler() {
                    track.removeEventListener('transitionend', handler);
                    isAnimating = false;
                }, { once: true });
            });
        });
    }

    prevBtn.addEventListener('click', goPrev);
    nextBtn.addEventListener('click', goNext);

    layoutItems();
    window.addEventListener('resize', layoutItems);
});
